import { render, staticRenderFns } from "./CustomerCreatePage.vue?vue&type=template&id=137754cd&"
import script from "./CustomerCreatePage.vue?vue&type=script&lang=js&"
export * from "./CustomerCreatePage.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCreatePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports